var React = require('react');

function Bag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.22622 9.83718C6.31068 9.246 6.81698 8.80688 7.41416 8.80688H16.946C17.5432 8.80688 18.0495 9.246 18.1339 9.83718L19.2545 17.6808C19.461 19.1267 18.3391 20.4202 16.8786 20.4202H7.48158C6.02106 20.4202 4.89915 19.1267 5.1057 17.6808L6.22622 9.83718Z","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M15.4983 11.2952V6.01637C15.4983 4.35042 14.3098 2.99991 12.8438 2.99991H11.5165C10.0505 2.99991 8.86206 4.35042 8.86206 6.01637V11.2952V11.2952","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M5.95871 16.6875H18.4016","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","key":2})]);
}

Bag.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Bag;

Bag.default = Bag;
